(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.getElementById('CartForm');
    const updateBtn = form?.querySelector('[data-cart-update]');
    if (!form || !updateBtn) return;

    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-quantity-select]')) {
        updateBtn.click();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-collection-section]');
    if (!section) return;

    document.querySelectorAll('[data-collection-section] [data-filter-input], [data-mobile-filters] [data-filter-input]').forEach((input) => {
      input.addEventListener('change', () => {
        window.location.href = input.checked ? input.dataset.urlAdd : input.dataset.urlRemove;
      });
    });

    const closeFilterDropdowns = (except) => {
      document.querySelectorAll('[data-filter-dropdown]').forEach((dropdown) => {
        if (except && dropdown === except) return;
        const button = dropdown.querySelector('[data-filter-dropdown-button]');
        const panel = dropdown.querySelector('[data-filter-dropdown-panel]');
        panel?.setAttribute('hidden', '');
        button?.setAttribute('aria-expanded', 'false');
      });
    };

    const closeSortDropdown = () => {
      const panel = section.querySelector('[data-sort-dropdown-panel]');
      const button = section.querySelector('[data-sort-dropdown-button]');
      panel?.setAttribute('hidden', '');
      button?.setAttribute('aria-expanded', 'false');
    };

    document.querySelectorAll('[data-filter-dropdown]').forEach((dropdown) => {
      const button = dropdown.querySelector('[data-filter-dropdown-button]');
      const panel = dropdown.querySelector('[data-filter-dropdown-panel]');

      button?.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = panel?.hasAttribute('hidden');
        closeSortDropdown();
        closeFilterDropdowns();
        if (willOpen) {
          panel?.removeAttribute('hidden');
          button.setAttribute('aria-expanded', 'true');
        }
      });

      panel?.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });

    const sortDropdown = section.querySelector('[data-sort-dropdown]');
    const sortButton = sortDropdown?.querySelector('[data-sort-dropdown-button]');
    const sortPanel = sortDropdown?.querySelector('[data-sort-dropdown-panel]');

    sortButton?.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = sortPanel?.hasAttribute('hidden');
      closeFilterDropdowns();
      if (willOpen) {
        sortPanel?.removeAttribute('hidden');
        sortButton.setAttribute('aria-expanded', 'true');
      } else {
        closeSortDropdown();
      }
    });

    sortPanel?.querySelectorAll('[data-sort-option]').forEach((option) => {
      option.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', option.dataset.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });

    document.addEventListener('click', () => {
      closeFilterDropdowns();
      closeSortDropdown();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeFilterDropdowns();
        closeSortDropdown();
      }
    });

    const dialog = document.querySelector('[data-mobile-filters]');
    const openBtn = section.querySelector('[data-mobile-filters-open]');
    const closeBtn = dialog?.querySelector('[data-mobile-filters-close]');

    openBtn?.addEventListener('click', () => dialog?.showModal());
    closeBtn?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deal-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-deal-hero]');
    if (!root) return;

    const slides = [...root.querySelectorAll('[data-deal-slide]')];
    if (slides.length < 2) return;

    const dots = [...root.querySelectorAll('[data-deal-dot]')];
    const prev = root.querySelector('[data-deal-prev]');
    const next = root.querySelector('[data-deal-next]');
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Number(root.dataset.interval) || 6000;
    let index = 0;
    let timer = null;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('opacity-0', !active);
        slide.classList.toggle('pointer-events-none', !active);
        slide.toggleAttribute('hidden', !active);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('bg-white', i === index);
        dot.classList.toggle('bg-white/40', i !== index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => show(index + 1), interval);
    };

    prev?.addEventListener('click', () => {
      show(index - 1);
      start();
    });
    next?.addEventListener('click', () => {
      show(index + 1);
      start();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.dealDot));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-localization-select]').forEach((select) => {
      select.addEventListener('change', () => {
        select.closest('form')?.requestSubmit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const syncHeaderHeight = () => {
      document.documentElement.style.setProperty('--site-header-height', `${header.offsetHeight}px`);
    };

    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(syncHeaderHeight).observe(header);
    }

    const mobileDialog = header.querySelector('[data-mobile-menu]');
    const openBtn = header.querySelector('[data-mobile-menu-open]');
    const closeBtn = header.querySelector('[data-mobile-menu-close]');

    openBtn?.addEventListener('click', () => {
      mobileDialog?.showModal();
      openBtn.setAttribute('aria-expanded', 'true');
    });

    closeBtn?.addEventListener('click', () => {
      mobileDialog?.close();
      openBtn?.setAttribute('aria-expanded', 'false');
    });

    mobileDialog?.addEventListener('click', (event) => {
      if (event.target === mobileDialog) {
        mobileDialog.close();
        openBtn?.setAttribute('aria-expanded', 'false');
      }
    });

    // Close the drawer before opening predictive search from within it.
    header.querySelector('[data-mobile-search]')?.addEventListener('click', () => {
      mobileDialog?.close();
      openBtn?.setAttribute('aria-expanded', 'false');
    });

    // Mobile menu accordion (Mirrors / Kids & Nursery / Customer service ...).
    header.querySelectorAll('[data-mobile-accordion]').forEach((accordionRoot) => {
      const accTriggers = accordionRoot.querySelectorAll('[data-maccordion-trigger]');
      accTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const id = trigger.dataset.maccordionTrigger;
          const panel = accordionRoot.querySelector(`[data-maccordion-panel="${id}"]`);
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          accTriggers.forEach((t) => {
            t.setAttribute('aria-expanded', 'false');
            const p = accordionRoot.querySelector(`[data-maccordion-panel="${t.dataset.maccordionTrigger}"]`);
            if (p) p.hidden = true;
          });

          if (!isOpen) {
            trigger.setAttribute('aria-expanded', 'true');
            if (panel) panel.hidden = false;
          }
        });
      });
    });

    const triggers = header.querySelectorAll('[data-desktop-menu-trigger]');
    const panels = header.querySelectorAll('[data-desktop-menu-panel]');
    let activePanel = null;

    const closePanels = () => {
      panels.forEach((panel) => {
        panel.hidden = true;
        panel.dataset.open = 'false';
      });
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      activePanel = null;
    };

    triggers.forEach((trigger) => {
      const id = trigger.dataset.desktopMenuTrigger;
      const panel = header.querySelector(`[data-desktop-menu-panel="${id}"]`);
      if (!panel) return;

      trigger.addEventListener('mouseenter', () => {
        closePanels();
        panel.hidden = false;
        panel.dataset.open = 'true';
        trigger.setAttribute('aria-expanded', 'true');
        activePanel = panel;
      });

      trigger.addEventListener('click', () => {
        const isOpen = panel.dataset.open === 'true';
        closePanels();
        if (!isOpen) {
          panel.hidden = false;
          panel.dataset.open = 'true';
          trigger.setAttribute('aria-expanded', 'true');
          activePanel = panel;
        }
      });
    });

    header.addEventListener('mouseleave', closePanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    const gallery = section.querySelector('[data-gallery]');
    if (gallery) {
      const thumbsCol = gallery.querySelector('[data-gallery-thumbs]');
      const mainStage = gallery.querySelector('[data-gallery-main-stage]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      const mains = gallery.querySelectorAll('[data-gallery-main]');

      const syncThumbColumnHeight = () => {
        if (!thumbsCol || !mainStage || window.matchMedia('(max-width: 639px)').matches) {
          if (thumbsCol) thumbsCol.style.height = '';
          return;
        }
        const visibleMain = mainStage.querySelector('[data-gallery-main]:not(.hidden)');
        if (!visibleMain) return;
        const height = visibleMain.getBoundingClientRect().height;
        if (height > 0) thumbsCol.style.height = `${height}px`;
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const idx = thumb.dataset.index;
          mains.forEach((m) => m.classList.toggle('hidden', m.dataset.index !== idx));
          thumbs.forEach((t) => {
            t.dataset.active = t === thumb ? 'true' : 'false';
          });
          thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          requestAnimationFrame(syncThumbColumnHeight);
        });
      });

      mains.forEach((main) => {
        main.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', syncThumbColumnHeight, { once: true });
        });
      });

      syncThumbColumnHeight();
      window.addEventListener('resize', syncThumbColumnHeight);
      if ('ResizeObserver' in window && mainStage) {
        const ro = new ResizeObserver(syncThumbColumnHeight);
        ro.observe(mainStage);
      }
    }

    const deliveryEl = section.querySelector('[data-delivery]');

    const renderDelivery = (available) => {
      if (!deliveryEl) return;
      const dot = deliveryEl.querySelector('[data-delivery-dot]');
      const textEl = deliveryEl.querySelector('[data-delivery-text]');
      const label = deliveryEl.querySelector('[data-delivery-label]');
      if (!label) return;

      if (available) {
        const leadDays = parseInt(deliveryEl.dataset.leadDays, 10) || 2;
        const locale = deliveryEl.dataset.locale || 'en';
        const date = new Date();
        let added = 0;
        while (added < leadDays) {
          date.setDate(date.getDate() + 1);
          const dow = date.getDay();
          if (dow !== 0 && dow !== 6) added += 1;
        }
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const isTomorrow = date.toDateString() === tomorrow.toDateString();

        let dateLabel = '';
        try {
          const when = isTomorrow
            ? deliveryEl.dataset.tomorrow
            : new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date);
          const dayMonth = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
          dateLabel = `${when} ${dayMonth}`;
        } catch (e) {
          dateLabel = '';
        }

        const eta = (deliveryEl.dataset.eta || '').replace('%DATE%', dateLabel);
        label.textContent = `${deliveryEl.dataset.inStock} ${eta}`.trim();
        if (textEl) textEl.className = 'product-pdp-lead flex items-center gap-2.5 text-sm font-medium text-green-600';
        if (dot) dot.className = 'inline-block size-2.5 rounded-full bg-green-500 motion-safe:animate-pulse';
      } else {
        label.textContent = deliveryEl.dataset.soldOut;
        if (textEl) textEl.className = 'product-pdp-lead flex items-center gap-2.5 text-sm font-medium text-gray-500';
        if (dot) dot.className = 'hidden';
      }
    };

    renderDelivery(deliveryEl?.dataset.available === 'true');

    const trustRotator = section.querySelector('[data-trust-rotator]');
    if (trustRotator) {
      const slides = Array.from(trustRotator.querySelectorAll('[data-trust-rotator-slide]'));
      if (slides.length > 1) {
        let active = 0;
        const show = (index) => {
          slides.forEach((slide, i) => {
            const on = i === index;
            slide.classList.toggle('opacity-0', !on);
            slide.classList.toggle('opacity-100', on);
            slide.classList.toggle('absolute', !on);
            slide.classList.toggle('inset-0', !on);
            slide.setAttribute('aria-hidden', on ? 'false' : 'true');
          });
        };
        show(active);
        window.setInterval(() => {
          active = (active + 1) % slides.length;
          show(active);
        }, 3000);
      }
    }

    const variants = JSON.parse(document.querySelector('[data-product-variants]')?.textContent || '[]');
    const form = section.querySelector('[data-product-form]');
    if (!form || variants.length === 0) return;

    const variantInput = form.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-product-price]');
    const stickyPriceEl = section.querySelector('[data-product-sticky-price]');
    const addBtn = form.querySelector('[data-add-to-cart]');
    const addText = form.querySelector('[data-add-to-cart-text]');
    const skuEl = section.querySelector('[data-spec-sku]');
    const eanEl = section.querySelector('[data-spec-ean]');
    const stickyAddBtn = section.querySelector('[data-product-sticky-add]');
    const stickyBar = section.querySelector('[data-product-sticky-bar]');
    const buyBoxAnchor = form;
    const optionInputs = form.querySelectorAll('[data-option-input]');

    const getSelectedOptions = () => {
      const options = [];
      optionInputs.forEach((input) => {
        const position = parseInt(input.dataset.optionPosition, 10);
        if (input.checked) options[position - 1] = input.value;
      });
      return options;
    };

    const findVariant = () => {
      const selected = getSelectedOptions();
      return variants.find((variant) =>
        variant.options.every((value, index) => value === selected[index])
      );
    };

    const formatMoney = (cents) => {
      return new Intl.NumberFormat(section.dataset.locale, {
        style: 'currency',
        currency: section.dataset.currency,
      }).format(cents / 100);
    };

    const renderPrice = (variant) => {
      let html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        const badge = (section.dataset.labelDiscount || '').replace('%PCT%', pct);
        html += `<span class="sr-only">${section.dataset.labelRegular}</span>`;
        html += `<s class="text-lg font-normal text-gray-400">${formatMoney(variant.compare_at_price)}</s>`;
        html += `<span class="sr-only">${section.dataset.labelSale}</span>`;
        html += `<span class="text-2xl font-medium text-gray-900">${formatMoney(variant.price)}</span>`;
        html += `<span class="text-sm font-semibold text-red-600">${badge}</span>`;
      } else {
        html += `<span class="text-2xl font-medium text-gray-900">${formatMoney(variant.price)}</span>`;
      }
      return html;
    };

    const renderStickyPrice = (variant) => {
      let html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += `<s class="mr-1 font-normal text-gray-400">${formatMoney(variant.compare_at_price)}</s>`;
      }
      html += formatMoney(variant.price);
      return html;
    };

    const setStickyVisible = (visible) => {
      if (!stickyBar) return;
      stickyBar.dataset.visible = visible ? 'true' : 'false';
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    const updateVariant = () => {
      const variant = findVariant();
      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML = renderPrice(variant);
      }

      if (stickyPriceEl) {
        stickyPriceEl.innerHTML = renderStickyPrice(variant);
      }

      const label = variant.available ? section.dataset.labelAdd : section.dataset.labelSoldOut;

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = label;

      if (stickyAddBtn) {
        stickyAddBtn.disabled = !variant.available;
        stickyAddBtn.textContent = label;
      }

      renderDelivery(variant.available);

      const shippingPdp = form.querySelector('[data-free-shipping-pdp]');
      const shippingText = form.querySelector('[data-free-shipping-pdp-text]');
      if (shippingPdp && shippingText) {
        const threshold = parseInt(shippingPdp.dataset.thresholdCents || '0', 10);
        shippingText.textContent =
          variant.price >= threshold ? shippingPdp.dataset.msgFree : shippingPdp.dataset.msgNote;
      }

      if (skuEl && variant.sku) skuEl.textContent = variant.sku;
      if (eanEl && variant.barcode) eanEl.textContent = variant.barcode;

      window.BuxiboKlarnaOsm?.updatePurchaseAmount?.('klarna-placement[data-klarna-osm-pdp]', variant.price);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

    stickyAddBtn?.addEventListener('click', () => {
      if (addBtn?.disabled) return;
      addBtn?.click();
    });

    if (stickyBar && buyBoxAnchor && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setStickyVisible(!entry.isIntersecting);
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -1px 0px' }
      );
      observer.observe(buyBoxAnchor);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
